export const STLogo = ({ className = "", variant = "light" }) => (
  <a
    href="/"
    className={`inline-flex items-center ${className}`}
    data-testid="st-logo"
    aria-label="Smart Terminals"
  >
    <img
      src="/brand/logo-transparent.png"
      alt="Smart Terminals"
      className={`h-9 md:h-10 w-auto object-contain ${variant === "dark" ? "brightness-0 invert" : ""}`}
      draggable="false"
    />
  </a>
);

export default STLogo;
